import { CombineProperties } from './combine-properties.model';

export class SearchTextHighlight extends CombineProperties {
    globalSearch: string;

    constructor() {
        super();
        this.globalSearch = '';
    }
}
